import { graphql, useStaticQuery } from 'gatsby'
import React, { useEffect } from 'react'

const query = graphql`
  query TokenSwapQuery {
    content: allFile(filter: { relativePath: { eq: "tokenSwap.json" } }) {
      edges {
        node {
          childContentJson {
            title {
              default
              timer
              progress
              done
            }
            url
            showLumaButton
          }
        }
      }
    }
  }
`

export default function tokenSwapNotificationContent() {
  const data = useStaticQuery(query)
  const content = data.content.edges[0].node.childContentJson
  const title = content.title.done
  const { showLumaButton } = content

  useEffect(() => {
    if (showLumaButton) {
      const script = document.createElement('script')
      script.src = 'https://embed.lu.ma/checkout-button.js'
      script.async = true
      script.id = 'luma-checkout'
      document.body.appendChild(script)

      return () => {
        const existingScript = document.getElementById('luma-checkout')
        if (existingScript) {
          existingScript.remove()
        }
      }
    }
  }, [showLumaButton])

  return {
    title,
    url: content.url,
    lumaButton: showLumaButton ? (
      <a
        href="https://lu.ma/event/evt-BU4pvQJpSOsnsKU"
        className="luma-checkout--button"
        data-luma-action="checkout"
        data-luma-event-id="evt-BU4pvQJpSOsnsKU"
      >
        Register for Event
      </a>
    ) : null
  }
}
